import React, { useEffect, useState, useCallback } from "react";
import { Api_Token } from "../../util/Api";
import {
  TextField,
  Button,
  Autocomplete,
  Box,
  Grid,
  MenuItem,
  Modal,
  Select,
} from "@mui/material";
import TitreGraphik from "../Typography/TitreGraphik";
import { MuiTelInput } from "mui-tel-input";
import LabelTypography from "../Typography/LabelTypography";
import { useTranslation } from "react-i18next";

export default function ModelUserCaisse({
  open,
  onClose,
  handleSubmit,
  data,
  formError,
  setFormData,
}) {
  const [caisses, setCaisses] = useState([]);
  const [filter, setFilter] = useState("");
  const { t } = useTranslation();

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", md: "50%" },
    backgroundColor: "white",
    boxShadow: 24,
    p: 4,
  };

  const fetchCaisses = useCallback(async () => {
    try {
      const response = await Api_Token.get(
        `caisses/getCaissePaginate?page=1&search=${filter}`
      );
      setCaisses(response.data.data);
    } catch (error) {
      console.error("Error fetching caisses:", error);
    }
  }, [filter]);

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchCaisses();
    }, 1000);
    return () => clearTimeout(timer);
  }, [fetchCaisses]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <TitreGraphik>
          {data?.id ? t("Edit User") : t("Add New User")}
        </TitreGraphik>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <LabelTypography>{t("full name")}</LabelTypography>
              <TextField
                fullWidth
                name="name"
                defaultValue={data?.name}
                required
                error={!!formError.name}
                helperText={formError.name}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <LabelTypography>{t("Caisse")}</LabelTypography>
              <Autocomplete
                options={caisses}
                getOptionLabel={(option) => option.nomCaisse}
                onInputChange={(event, value) => setFilter(value)}
                value={
                  caisses.find((caisse) => caisse.id === data?.idCaisse) || null
                }
                onChange={(event, value) =>
                  setFormData((prev) => ({
                    ...prev,
                    idCaisse: value?.id || null,
                  }))
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    required
                    error={!!formError.idCaisse}
                    helperText={formError.idCaisse}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <LabelTypography>{t("Role")}</LabelTypography>
              <Select
                name="Role"
                defaultValue={data?.Role || "commercial"}
                fullWidth
              >
                <MenuItem value="commercial">Commercial</MenuItem>
                <MenuItem value="captain">Captain</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={6}>
              <LabelTypography>{t("Phone Number")}</LabelTypography>
              <MuiTelInput
                defaultCountry="VU"
                name="Number"
                value={data.Number}
                onChange={(value) => {
                  setFormData((prev) => ({
                    ...prev,
                    Number: value || "+678",
                  }));
                }}
                fullWidth
              />
            </Grid>
            {!data?.id && (
              <>
                <Grid item xs={12} md={6}>
                  <LabelTypography>{t("Email")}</LabelTypography>
                  <TextField
                    type="text"
                    placeholder={t("Email")}
                    name="email"
                    defaultValue={data?.email}
                    fullWidth
                    error={!!formError?.email}
                    helperText={formError?.email}
                    required
                  />
                </Grid>

                <Grid item xs={12}>
                  <LabelTypography>{t("Password")}</LabelTypography>
                  <TextField
                    type="password"
                    placeholder={t("Password")}
                    name="password"
                    defaultValue={data?.password}
                    fullWidth
                    error={!!formError?.password}
                    helperText={formError?.password}
                    required
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <Grid container spacing={2} justifyContent="flex-end">
                <Grid item>
                  <Button variant="contained" color="error" onClick={onClose}>
                    {t("Cancel")}
                  </Button>
                </Grid>
                <Grid item>
                  <Button type="submit" variant="contained" color="primary">
                    {data.id ? t("Update") : t("Create")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
}
